import CodeBlock from "../../common/code_block";
import ErrorCodesLink from "../../common/ErrorCodesLink";
import EnvelopeRows from "../../common/EnvelopeRows";
import HeaderWithTag from "../../common/header_with_tag";
import { ICredentials } from "../../types/types";
import TryGetEntities from "./try";
import { Link } from 'react-router-dom';
import { HOST_API_URL } from "../../config";


const responseCode = `{
  "statusCode": 200,
  "message": "Success",
  "errorCode": null,
  "data": [
    {
      "name": "EDAHAB",
      "type": "Wallet",
      "country": "SOMALIA",
      "agentId": "HRG",
      "description": "Edahab Mobile Money"
    },
    {
      "name": "MPESA",
      "type": "Wallet",
      "country": "KENYA",
      "agentId": "NBO",
      "description": "Mpesa Mobile Money"
    }
  ]
}`;

function GetEntities() {
    return (
        <div className="page">
            <div className="app-content main-content mt-0">
                <div className="side-app">
                    <div className="main-container container-fluid">
                        <div className="page-header">
                            <div>
                                <h1 className="page-title">Get Entities</h1>
                            </div>
                            <div className="ms-auto pageheader-btn">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="javascript:void(0);">Docs</a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Get Entities
                                    </li>
                                </ol>
                            </div>
                        </div>

                        <div className="card overflow-hidden">
                            <div className="row">
                                <div className="col-md-7" style={{ position: "relative" }}>
                                    <div className="card-body border-end p-0">
                                        <div className="p-5">
                                            <HeaderWithTag
                                                headerText="Retrieve supported entities"
                                                headerTag="description"
                                            />
                                            <p className="text-12">
                                                <span className="badge badge-sm bg-blue text-white me-2">
                                                    GET
                                                </span>
                                                {HOST_API_URL}/Common/GetEntities
                                            </p>
                                            <p className="text-muted text-14" style={{ textAlign: "justify" }}>
                                                Returns the list of entities currently enabled for remittance processing.
                                                This endpoint provides information about available entities for transactions.
                                            </p>

                                            <div className="my-5">
                                                <HeaderWithTag
                                                    headerText="Response"
                                                    headerTag="response"
                                                />
                                                <div className="table-responsive">
                                                    <table className="table text-nowrap text-md-nowrap table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>Parameters</th>
                                                                <th>Type</th>
                                                                <th>Description</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <EnvelopeRows />
                                                            <tr>
                                                                <td>data[].name</td>
                                                                <td>string</td>
                                                                <td>The name of the entity (e.g., EDAHAB, MPESA).</td>
                                                            </tr>
                                                            <tr>
                                                                <td>data[].type</td>
                                                                <td>string</td>
                                                                <td>The type of entity (e.g., Wallet, Bank).</td>
                                                            </tr>
                                                            <tr>
                                                                <td>data[].country</td>
                                                                <td>string</td>
                                                                <td>Country the entity operates in.</td>
                                                            </tr>
                                                            <tr>
                                                                <td>data[].agentId</td>
                                                                <td>string</td>
                                                                <td>Agent identifier for the entity.</td>
                                                            </tr>
                                                            <tr>
                                                                <td>data[].description</td>
                                                                <td>string</td>
                                                                <td>Human-readable description of the entity.</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div className="my-5">
                                                <CodeBlock
                                                    code={responseCode}
                                                    codeBlackText="Response Simple"
                                                    codeLanguage="json"
                                                />
                                            </div>

                                            <ErrorCodesLink />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5 pt-5">
                                    <h5 className="card-title text-primary">
                                        Code Samples
                                    </h5>

                                    <TryGetEntities
                                        codeBlackTitle="Request Simple"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GetEntities;